<template>
  <div class="pills-box">
    <p class="pills-box__title">{{ title }}</p>
    <div class="pills-box__list">
      <Pill
        v-for="pill in pills"
        :key="pill.id"
        :text="pill.text"
        :iconTypeVal="IconType.PLUS"
        @pill-selected="onPillSelected"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Pill, {IconType} from '@common/pills/pill.vue';

export default Vue.extend({
  components: {Pill},
  data() {
    return {
      IconType,
    };
  },
  name: 'SuggestionsBox',
  props: {
    title: {
      type: String,
      default: () => 'Suggested:',
    },
    pills: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onPillSelected(text) {
      this.$emit('pill-selected', text);
    },
  },
});
</script>

<style scoped lang="scss">
.pills-box {
  display: flex;
  align-items: center;
  &__list {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-right: 10px;
    margin-right: 320px;
    overflow: hidden;
    flex-wrap: wrap;
    max-height: 33px;
  }
  &__title {
    color: #7f7f7f;
    font-size: 12px;
    font-weight: 700;
    line-height: normal;
    margin: 0 11px 0 0;
  }
  &__browse-all {
    color: #e14645;
    font-size: 12px;
    font-weight: 700;
    line-height: normal;
    padding-bottom: 4px;
    padding-right: 14px;
    padding-left: 0;
    position: relative;
    border: none;
    background: transparent;
    border-bottom: 1px solid #e14645;
    &:hover {
      cursor: pointer;
    }
    &:after {
      content: '';
      display: block;
      position: absolute;
      right: 0;
      top: 4px;
      width: 0;
      height: 0;
      border-top: 3px solid transparent;
      border-bottom: 3px solid transparent;
      border-left: 6px solid #e14645;
    }
  }
}
</style>
